import { QuestionGroup, ScenarioStep, Steps } from '../state/interfaces'
import { addressLocation, emailAddress, confirm, thanks } from './common-steps'

export const addressLocationCheckAvailability: ScenarioStep = {
  ...addressLocation,
  group: QuestionGroup.CHECK_AVAILABILITY,
  next: Steps.EMAIL_ADDRESS,
}

export const emailAddressCheckAvailability: ScenarioStep = {
  ...emailAddress,
  group: QuestionGroup.CHECK_AVAILABILITY,
  next: Steps.CONFIRM_CHECK_AVAILABILITY,
}

export const confirmCheckAvailability: ScenarioStep = {
  ...confirm,
  id: Steps.CONFIRM_CHECK_AVAILABILITY,
  group: QuestionGroup.CHECK_AVAILABILITY,
  answerPlaceholder: 'confirm-check-availability_answerPlaceholder',
  next: Steps.THANKS,
}

export const thanksCheckAvailability: ScenarioStep = {
  ...thanks,
}
